import React from 'react';
import { Route } from 'react-router-dom';
import { WithAuthentication } from '@twigeducation/oidc-client-react';
import interactiveUrl from './urls';
import UpdatePasswordRequired from '../../components/UpdatePasswordRequired';

const Interactive = React.lazy(() => import(/* webpackChunkName: "Interactive" */ '.'));

const routes = [
    <Route path={`${interactiveUrl}/:slug/:id`} exact key="interactive-with-slug">
        <WithAuthentication>
            <UpdatePasswordRequired>
                <Interactive />
            </UpdatePasswordRequired>
        </WithAuthentication>
    </Route>,
    <Route path={`${interactiveUrl}/:id`} exact key="interactive-without-slug">
        <WithAuthentication>
            <UpdatePasswordRequired>
                <Interactive />
            </UpdatePasswordRequired>
        </WithAuthentication>
    </Route>,
];

const generateInteractiveRoute = (slug, id) => `${interactiveUrl}/${slug}/${btoa(id)}`;

export { generateInteractiveRoute };

export default routes;
